import { render, staticRenderFns } from "./FaqThemeAdd.vue?vue&type=template&id=1c880a9c"
import script from "./FaqThemeAdd.vue?vue&type=script&lang=js"
export * from "./FaqThemeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports